import React from 'react';
import { Row, Col } from 'reactstrap';

const KeyValidityDisplay = ({ order, screeningDate }) => {
    const formatTime = (date) => {
        return date.toLocaleDateString([], { hour: '2-digit', minute: '2-digit', hour12: true }).split(',')[1];
    };

    const addTimeToDate = (date, amount = 0, unit = 'hours') => {
        const result = new Date(date);
        if (unit === 'days') {
            result.setDate(result.getDate() + amount);
        } else {
            result.setHours(result.getHours() + amount);
        }
        return result;
    };

    if (!screeningDate) {
        return (
            <div className="bg-body-tertiary bg-opacity-10 p-3 border-start border-primary border-3 d-flex justify-content-start align-items-center gap-5">
                <span className="fas fa-calendar me-2" /> Pick a screening date to view key validity
            </div>
        );
    }

    const period = order.version.defaultHirePeriod || 0;
    const unit = order.version.hirePeriodType;
    const validUntil = addTimeToDate(screeningDate, period, unit);

    return (
        <div className="bg-body-tertiary bg-opacity-10 p-3 border-start border-primary border-3 d-flex justify-content-start align-items-center gap-5">
            <Row className="w-100">
                <Col className="me-4 ms-2">
                    <p className="small text-uppercase text-nowrap">
                        <span className="fas fa-clock me-2 text-primary" />
                        Hire period
                    </p>
                    <p className="lead mb-0">{`${order.version.defaultHirePeriod} ${order.version.hirePeriodType}`}</p>
                </Col>
                <Col className="me-4 ms-2">
                    <p className="small text-uppercase text-nowrap">
                        <span className="fas fa-calendar-day me-2 text-primary" />
                        Valid from
                    </p>
                    <p className="lead mb-0">{screeningDate.toLocaleDateString()}</p>
                    <p className="">{` at: ${formatTime(screeningDate)}`}</p>
                </Col>
                <Col className="sm d-none d-md-block">
                    <span className="text-primary fas fa-arrow-right me-4 mt-4 pt-3" />
                </Col>
                <Col className="me-4 ms-2">
                    <p className="small text-uppercase text-nowrap">
                        <span className="fas fa-calendar-check me-2 text-primary" />
                        Valid until
                    </p>
                    <p className="lead mb-0">{validUntil.toLocaleDateString()}</p>
                    <p className="">{` at: ${formatTime(validUntil)}`}</p>
                </Col>
            </Row>
        </div>
    );
};

export default KeyValidityDisplay;
